/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2014, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../lib/@waca/core-client/js/core-client/ui/core/View',
	'react-dom',
	'react'
], function(View, ReactDOM, React) {

	// The custom Content uses the react rendere extension, but it is used in the old tooltip which is jquery based
	// This class will bridge the 2 technologies

	var CustomContent = View.extend({
		init: function(tooltipContentRenderer, options) {
			CustomContent.inherited('init', this, arguments);
			this.tooltipContentRenderer = tooltipContentRenderer;
			this.options = options;
		},
		render: function() {
			try {
				const components  = this.tooltipContentRenderer.getComponentList(this.options);
				ReactDOM.render(
					<div className= { 'tooltipContainer' }>
						{components}
					</div>,
					this.$el[0]
				);
			} catch(e) {
				this.$el.append(e.toString());
			}
		}
	});

	return CustomContent;
});
